!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("react"), require("@tinacms/forms")) : "function" == typeof define && define.amd ? define(["exports", "react", "@tinacms/forms"], n) : n((e = e || self)["@tinacms/react-core"] = {}, e.React, e.forms);
}(this, function (e, a, u) {
  "use strict";

  var n = "useCMS could not find an instance of CMS",
      t = a.createContext(null);

  function r() {
    var e = a.useContext(t);
    if (!e) throw new Error(n);
    return e;
  }

  var _i = function i() {
    return (_i = Object.assign || function (e) {
      for (var n, t = 1, u = arguments.length; t < u; t++) {
        for (var r in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  var o = f;

  function f(e) {
    var n,
        t = r();
    n = Array.isArray(e) ? e : [e], a.useEffect(function () {
      return n.forEach(function (e) {
        e && t.plugins.add(e);
      }), function () {
        n.forEach(function (e) {
          e && t.plugins.remove(e);
        });
      };
    }, function () {
      for (var e = 0, n = 0, t = arguments.length; n < t; n++) {
        e += arguments[n].length;
      }

      var u = Array(e),
          r = 0;

      for (n = 0; n < t; n++) {
        for (var i = arguments[n], o = 0, f = i.length; o < f; o++, r++) {
          u[r] = i[o];
        }
      }

      return u;
    }([t.plugins], n));
  }

  function c(e, n) {
    void 0 === n && (n = {});

    var t = e.loadInitialValues,
        u = function (e, n) {
      var t = {};

      for (var u in e) {
        Object.prototype.hasOwnProperty.call(e, u) && n.indexOf(u) < 0 && (t[u] = e[u]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;

        for (u = Object.getOwnPropertySymbols(e); r < u.length; r++) {
          n.indexOf(u[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, u[r]) && (t[u[r]] = e[u[r]]);
        }
      }

      return t;
    }(e, ["loadInitialValues"]);

    u.initialValues = u.initialValues || n.values;
    var r = a.useState(u.initialValues)[1],
        i = a.useState(function () {
      return s(u, function (e) {
        r(e.values);
      });
    }),
        o = i[0],
        f = i[1];
    return a.useEffect(function () {
      o.id !== u.id && f(s(u, function (e) {
        r(e.values);
      }));
    }, [u.id]), a.useEffect(function () {
      t && t().then(function (e) {
        o.updateInitialValues(e);
      });
    }, [o]), function (e, n) {
      a.useEffect(function () {
        void 0 !== n && e.updateFields(n);
      }, [e, n]);
    }(o, n.fields), function (e, n) {
      a.useEffect(function () {
        void 0 !== n && (e.label = n);
      }, [e, n]);
    }(o, n.label), function (e, n) {
      a.useEffect(function () {
        void 0 !== n && e.updateValues(n);
      }, [e, n]);
    }(o, n.values), [o ? o.values : u.initialValues, o];
  }

  function s(e, n) {
    var t = new u.Form(e);
    return t.subscribe(n, {
      values: !0
    }), t;
  }

  function l(n, t) {
    return function (e) {
      return o(t), a.createElement(n, _i({}, e));
    };
  }

  var v = l;
  e.CMSContext = t, e.ERROR_MISSING_CMS = n, e.useCMS = r, e.useForm = c, e.useLocalForm = function (e, n) {
    void 0 === n && (n = {});
    var t = c(e, n),
        u = t[0],
        r = t[1];
    return f(r), [u, r];
  }, e.usePlugin = o, e.usePlugins = f, e.useSubscribable = function (e, n) {
    var t = a.useState(0)[1];
    a.useEffect(function () {
      return e.subscribe(function () {
        t(function (e) {
          return e + 1;
        }), n && n();
      });
    });
  }, e.useWatchFormValues = function (e, t) {
    a.useEffect(function () {
      if (e) {
        var n = !0;
        return e.subscribe(function (e) {
          n ? n = !1 : t(e);
        }, {
          values: !0
        });
      }
    }, [t, e]);
  }, e.withPlugin = v, e.withPlugins = l, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});